import { useNavigate } from "react-router-dom";
import { Page, BrandHeader, CloseBtn } from "@/components/Brand";
import { EMS_DOMAINS, EMS_SCHEMAS } from "@/lib/config";
import { schemaScript } from "@/lib/schemaFlip";

export default function Schemas() {
  const navigate = useNavigate();
  return (
    <Page>
      <BrandHeader right={<CloseBtn onClick={() => navigate(-1)} testId="schemas-close" />} />
      <h1 className="mt-8 text-4xl font-bold text-t-on">Schema library</h1>
      <p className="mt-2 text-t-on2">The 18 early maladaptive schemas, grouped by the five domains of core needs — and their adaptive flip.</p>
      {EMS_DOMAINS.map((d) => (
        <section key={d} className="mt-8">
          <h2 className="tf-tag mb-3">{d}</h2>
          <div className="flex flex-col gap-3">
            {EMS_SCHEMAS.filter((s) => s.domain === d).map((s) => {
              const sc = schemaScript(s.name);
              return (
                <div key={s.name} className="tf-card p-5" data-testid={`schema-${s.name.split(" ")[0].toLowerCase()}`}>
                  <p className="font-bold text-t-on">{s.name}</p>
                  <p className="mt-1 text-sm text-t-on2">{s.definition}</p>
                  {sc ? (
                    <div className="mt-3 grid sm:grid-cols-2 gap-3 text-sm">
                      <p className="rounded-xl p-3 italic" style={{ background: "color-mix(in srgb, var(--hot) 12%, transparent)", color: "var(--hot)" }}>“{sc.script}”</p>
                      <p className="rounded-xl p-3 bg-t-brand3 text-t-on"><span className="block font-semibold text-t-brand">{sc.adaptive}</span>“{sc.adaptiveScript}”</p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </section>
      ))}
    </Page>
  );
}
